export default __webpack_public_path__ + "static/media/A0000.7bbb734d.png";